// @ts-ignore
import { /*loader,*/ gql } from "graphql.macro";

const collections = gql`
  query collections {
    collections
      @rest(type: "LiveDataPanelCollection", path: "livedata/collections/") {
      name
      category
      nodeFilter
      listItemClass
      onlyAdmin
      onlyList
      showSpecialTabs
      maxDaysBeforeFiltered
      miniPanelBean
      miniPanelURL
      tabManager
      panelDefinition @type(name: "LiveDataPanelCollection") {
        id
        template
        required
        alwaysShow
        visible
        showInList
        showInMapExpanded
        showInMapCollapsed
        showInVI
      }
    }
  }
`;

export default collections;
